import { render, staticRenderFns } from "./sjypzDialog.vue?vue&type=template&id=0d1f63d3&scoped=true&"
import script from "./sjypzDialog.vue?vue&type=script&lang=js&"
export * from "./sjypzDialog.vue?vue&type=script&lang=js&"
import style0 from "./sjypzDialog.vue?vue&type=style&index=0&id=0d1f63d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f63d3",
  null
  
)

export default component.exports